const classSignIn = {
  path: 'classSingIn/:myClassId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/classSingIn'], resolve)
}
export default classSignIn
